import {
    createContext,
    FunctionComponent,
    PropsWithChildren,
    ReactElement,
} from "react";

import { TaskStageViewModel } from "../view-models";
import { useTasksContextValue } from "./useContextTasksValue";
import { TaskInfoAddRequestTaskTypeEnum } from "@/api/openapi";

export interface IStoredTask {
    taskInfoId: string;
    taskType: TaskInfoAddRequestTaskTypeEnum;
    stage: TaskStageViewModel;
    deviceIdentity: string; // Lets us easily filter by deviceId
    result?: string;
}

/**
 * This is not actually a store, and is used only for the Task Toaster.
 * To reliably access all recieved task messages, refer to data-source-service
 */
export interface ITaskContextData {
    tasks: IStoredTask[];
    createTask: (task: IStoredTask) => void;
    updateTask: (task: IStoredTask) => void;
    removeTask: (taskId: string) => void;
    getTask: (
        deviceId: string,
        taskType: TaskInfoAddRequestTaskTypeEnum,
    ) => IStoredTask | undefined | null;
    getTaskFromId: (taskId: string) => IStoredTask | undefined | null;
}

const tasksContextDefaultValue = {
    tasks: [],
    createTask: () => null,
    updateTask: () => null,
    removeTask: () => null,
    getTask: () => null,
    getTaskFromId: () => null,
};

export const TasksContext = createContext<ITaskContextData>(
    tasksContextDefaultValue,
);

export const TasksProvider: FunctionComponent<PropsWithChildren> = (
    options,
): ReactElement => {
    const tasksContextValue = useTasksContextValue();

    return (
        <>
            <TasksContext value={tasksContextValue}>
                {options.children}
            </TasksContext>
        </>
    );
};
